import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import NumberComponentTextBox from "./InputComponents/NumberComponentTextBoxComponent";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import NumberComponent from "./InputComponents/NumberComponent";
import DropDTextMultiple from "./InputComponents/DropDTextMultipleComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";
interface ImpactsProps {
    errors: string[];
    isCBE: boolean;
    dropdownValues: {
        tab: string;
        inputName: string;
        listValue: string[];
    }[];

    tAndP:
    {
        table: string;
        property: string;
        tooltip: string;
        placeholder: string;
        id: string;
    }[];
    data: {
        //set 1 BBI CBE
        numberJobs: number | null;

        location: string[];
        locationText: string;
        locationSensitive: boolean;

        typeJob: string[];
        typeJobText: string;
        typeJobSensitive: boolean;

        // indirects

        numberJobsIndirect: number | null;

        locationIndirect: string[];
        locationIndirectText: string;
        locationIndirectSensitive: boolean;

        typeJobIndirect: string[];
        typeJobIndirectText: string;
        typeJobIndirectSensitive: boolean;
        // set 2 cbe

        isContributingToDevSkillAndCapacity: string;
        isContributingToDevSkillAndCapacityText: string;
        isContributingToDevSkillAndCapacitySensitive: boolean;

        // set 4 cbe

        nRegionalHubs: number | null;
        nRegionalHubsText: string;
        nRegionalHubsSensitive: boolean;

        // set 5 cbe

        projectHasSynergies: string;

        hasSynergiesWithEU: string[];
        hasSynergiesWithEUText: string;
        hasSynergiesWithEUSensitive: boolean;

        hasSynergiesWithNational: string[];
        hasSynergiesWithNationalText: string;
        hasSynergiesWithNationalSensitive: boolean;

        hasSynergiesWithRegional: string[];
        hasSynergiesWithRegionalText: string;
        hasSynergiesWithRegionalSensitive: boolean;

        // set 2 BBI

        scienceAndInnovation: string[];
        scienceAndInnovationText: string;
        scienceAndInnovationSensitive: boolean;

        // set 3 BBI

        educationAndSociety: string[];
        educationAndSocietyText: string;
        educationAndSocietySensitive: boolean;

        // set 4 BBI

        standardsRegulationsPolicies: string[];
        standardsRegulationsPoliciesText: string;
        standardsRegulationsPoliciesSensitive: boolean;

        // set 5 BBI

        healthSafety: string[];
        healthSafetyText: string;
        healthSafetySensitive: boolean;

        // set 6 BBI

        impactOnPrimaryProducers: string[];
        impactOnPrimaryProducersText: string;
        impactOnPrimaryProducersSensitive: boolean;

        // set 7 BBI

        regionalAndLocalImpact: string[];
        regionalAndLocalImpactText: string;
        regionalAndLocalImpactSensitive: boolean;

        // set 8 BBI

        environmentalImpact: string[];
        environmentalImpactText: string;
        environmentalImpactSensitive: boolean;

        // set 9 BBI

        contributesBiodiversity: string[];
        contributesBiodiversityText: string;
        contributesBiodiversitySensitive: boolean;
    };

    handleOnChangeImpacts: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    customLabelValues: {
        table: string;
        property: string;
        value: string;
        id: string;
    }[];
    handleUpdateEditableTitle: (id: string, value: string) => void;
}

function Impacts({
    errors,
    data,
    handleOnChangeImpacts,
    isCBE,
    dropdownValues,
    customLabelValues,
    handleUpdateEditableTitle,
    tAndP
}: ImpactsProps) {
    const [isHidden, setIsHidden] = useState(false);
    const toggleVisibility = () => {
        setIsHidden((prevState) => !prevState);
    };
    const [socioEconomicImpactsIsHidden, setSocioEconomicImpactsIsHidden] =
        useState(true);
    const toggleVisibilitySocioEconomicImpacts = () => {
        setSocioEconomicImpactsIsHidden((prevState) => !prevState);
    };
    const [environmentalImpactIsHidden, setEnvironmentalImpactIsHidden] =
        useState(true);
    const toggleVisibilityEnvironmentalImpact = () => {
        setEnvironmentalImpactIsHidden((prevState) => !prevState);
    };
    return (
        <div className="feedstock-container">
            
            <h2 className="container-title">Impacts</h2>
            <div className={isHidden ? "hidden-content" : "visible-content"}>
                <div className="form-container">
                    <div className="error-container">
                        {errors.map((error, index) => (
                            <div
                                className="error-text"
                                key={index}
                                style={{ marginBottom: "10px" }}
                            >
                                {error}
                            </div>
                        ))}
                    </div>
                    <div className="question-group-input-first">
                        <div className="questions-wrapper">
                            <div className="question-text">New direct jobs </div>
                            <NumberComponent
                                numberLabel={
                                    "Number of new direct jobs by the end of the project"
                                }
                                numberValid={true}
                                numberValue={data.numberJobs}
                                numberName={"numberJobs"}
                                max={10000}
                                min={0}
                                onChange={handleOnChangeImpacts}
                                display={false}
                            />
                            <div className="row">
                                <div className="col-12">
                                    <div
                                        className={
                                            data.numberJobs != null && data.numberJobs > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "location"
                                                )[0].listValue
                                            }
                                            label={"Location"}
                                            inputName={"location"}
                                            value={data.location}
                                            handleOnChange={handleOnChangeImpacts}
                                            isValid={data.location.length > 0}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.numberJobs != null &&
                                                data.numberJobs > 0 &&
                                                data.location.length > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <TextConfidential
                                            label={"Please explain the assumptions made for the estimate"}
                                            textValid={
                                                data.locationText.length > 4 ||
                                                !data.location.includes("Others")
                                            }
                                            textValue={data.locationText}
                                            textName={"locationText"}
                                            onChange={handleOnChangeImpacts}
                                            isConfidential={data.locationSensitive}
                                            confidentialInputName={"locationSensitive"}
                                            display={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.numberJobs != null && data.numberJobs > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "typeJob"
                                                )[0].listValue
                                            }
                                            label={"Type of jobs"}
                                            inputName={"typeJob"}
                                            value={data.typeJob}
                                            handleOnChange={handleOnChangeImpacts}
                                            isValid={data.typeJob.length > 0}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.typeJob.length > 0 &&
                                                data.numberJobs != null &&
                                                data.numberJobs > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <TextConfidential
                                            label={"Please elaborate on the type of jobs created"}
                                            textValid={
                                                data.typeJobText.length > 4 ||
                                                !data.typeJob.includes("Others")
                                            }
                                            textValue={data.typeJobText}
                                            textName={"typeJobText"}
                                            onChange={handleOnChangeImpacts}
                                            isConfidential={data.typeJobSensitive}
                                            confidentialInputName={"typeJobSensitive"}
                                            display={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                            <div className="much-margin-top" />
                        <div className="questions-wrapper">
                            <div className="question-text">New indirect jobs </div>
                            <NumberComponent
                                numberLabel={
                                    "Number of new indirect jobs by the end of the project"
                                }
                                numberValid={true}
                                numberValue={data.numberJobsIndirect}
                                numberName={"numberJobsIndirect"}
                                max={10000}
                                min={0}
                                onChange={handleOnChangeImpacts}
                                display={false}
                            />
                            <div className="row">
                                <div className="col-12">
                                    <div
                                        className={
                                            data.numberJobsIndirect != null &&
                                                data.numberJobsIndirect > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "location"
                                                )[0].listValue
                                            }
                                            label={"Location"}
                                            inputName={"locationIndirect"}
                                            value={data.locationIndirect}
                                            handleOnChange={handleOnChangeImpacts}
                                            isValid={data.locationIndirect.length > 0}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.numberJobsIndirect != null &&
                                                data.numberJobsIndirect > 0 &&
                                                data.locationIndirect.length > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <TextConfidential
                                            label={"Please explain the assumptions made for the estimate"}
                                            textValid={
                                                data.locationIndirectText.length > 4 ||
                                                !data.locationIndirect.includes("Others")
                                            }
                                            textValue={data.locationIndirectText}
                                            textName={"locationIndirectText"}
                                            onChange={handleOnChangeImpacts}
                                            isConfidential={data.locationIndirectSensitive}
                                            confidentialInputName={"locationIndirectSensitive"}
                                            display={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.numberJobsIndirect != null &&
                                                data.numberJobsIndirect > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "typeJob"
                                                )[0].listValue
                                            }
                                            label={"Type of jobs"}
                                            inputName={"typeJobIndirect"}
                                            value={data.typeJobIndirect}
                                            handleOnChange={handleOnChangeImpacts}
                                            isValid={data.typeJobIndirect.length > 0}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.typeJobIndirect.length > 0 &&
                                                data.numberJobsIndirect != null &&
                                                data.numberJobsIndirect > 0
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <TextConfidential
                                            label={"Please elaborate on the type of jobs created"}
                                            textValid={
                                                data.typeJobIndirectText.length > 4 ||
                                                !data.typeJobIndirect.includes("Others")
                                            }
                                            textValue={data.typeJobIndirectText}
                                            textName={"typeJobIndirectText"}
                                            onChange={handleOnChangeImpacts}
                                            isConfidential={data.typeJobIndirectSensitive}
                                            confidentialInputName={"typeJobIndirectSensitive"}
                                            display={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>

                        {/* ##### CBE ##### */}
                        {isCBE ? (
                            <>
                                {/* #### SET 2 CBE #### */}
                                <div className="question-group-input">

                                    <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 9")?.tooltip}>
                                        <>
                                            <div className="question-text">
                                                CBE JU KPI 9  🛈 <br />
                                                <EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "isContributingToDevSkillAndCapacity")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                            </div>
                                            <div className="small-text">
                                                please refer to specific activities listed in the DoA, referring to tasks and WPs
                                            </div>
                                        </>
                                    </Tooltip>
                                    <div className="row">
                                        <div className="col-12">
                                            <DropdownStringMandatory
                                                listInputs={["-", "Yes", "No"]}
                                                label={""}
                                                inputName={"isContributingToDevSkillAndCapacity"}
                                                value={data.isContributingToDevSkillAndCapacity}
                                                handleOnChange={handleOnChangeImpacts}
                                                invalidValues={["", "-"]}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <TextConfidential
                                                label={"Please explain how"}
                                                textValid={
                                                    data.isContributingToDevSkillAndCapacityText.length >
                                                    4
                                                }
                                                textValue={data.isContributingToDevSkillAndCapacityText}
                                                textName={"isContributingToDevSkillAndCapacityText"}
                                                onChange={handleOnChangeImpacts}
                                                display={
                                                    data.isContributingToDevSkillAndCapacity != "Yes"
                                                }
                                                isConfidential={
                                                    data.isContributingToDevSkillAndCapacitySensitive
                                                }
                                                confidentialInputName={
                                                    "isContributingToDevSkillAndCapacitySensitive"
                                                }
                                                placeholder={tAndP.find(item => item.property == "CBE JU KPI 9")?.placeholder}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* #### SET 4 CBE #### */}

                                <div className="question-group-input">

                                    <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 10.2")?.tooltip}>
                                        <div className="question-text">
                                            CBE JU KPI 10.2  🛈
                                            <br />
                                            <EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "nRegionalHubs")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                        </div>
                                    </Tooltip>
                                    <div className="row">
                                        <div className="col-12">
                                            <DropdownNumberMandatory
                                                listInputs={ListOfTwenty}
                                                label={""}
                                                inputName={"nRegionalHubs"}
                                                value={data.nRegionalHubs}
                                                handleOnChange={handleOnChangeImpacts}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <TextConfidential
                                                label={
                                                    "Please explain the objective(s) of the hub(s), their composition, etc…"
                                                }
                                                textValid={data.nRegionalHubsText.length > 4}
                                                textValue={data.nRegionalHubsText}
                                                textName={"nRegionalHubsText"}
                                                onChange={handleOnChangeImpacts}
                                                isConfidential={data.nRegionalHubsSensitive}
                                                confidentialInputName={"nRegionalHubsSensitive"}
                                                display={
                                                    data.nRegionalHubs == null || data.nRegionalHubs < 1
                                                }
                                                placeholder={tAndP.find(item => item.property == "CBE JU KPI 10.2")?.placeholder}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* #### SET 5 CBE #### */}

                                <div className="question-group-input">

                                    <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 10.3")?.tooltip}>
                                        <div className="question-text">
                                            CBE JU KPI 10.3  🛈 <br />
                                            <EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "projectHasSynergies")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                        </div>
                                    </Tooltip>
                                    <DropdownStringMandatory
                                        listInputs={["-", "Yes", "No"]}
                                        label={""}
                                        inputName={"projectHasSynergies"}
                                        value={data.projectHasSynergies}
                                        handleOnChange={handleOnChangeImpacts}
                                        invalidValues={["", "-"]}
                                    />
                                    <div
                                        className={
                                            data.projectHasSynergies == "Yes"
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <div className="row">
                                            <div className="question-text much-margin-top">
                                                EU Funding Programmes
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) => item.inputName == "hasSynergiesWithEU"
                                                        )[0].listValue
                                                    }
                                                    label={"Horizon Europe"}
                                                    inputName={"hasSynergiesWithEU"}
                                                    value={data.hasSynergiesWithEU}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please provide concrete examples of projects and funding schemes/mechanisms"}
                                                    textValid={
                                                        data.hasSynergiesWithEUText.length > 4 ||
                                                        !data.hasSynergiesWithEU.includes("Others")
                                                    }
                                                    textValue={data.hasSynergiesWithEUText}
                                                    textName={"hasSynergiesWithEUText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.hasSynergiesWithEUSensitive}
                                                    confidentialInputName={"hasSynergiesWithEUSensitive"}
                                                    display={data.hasSynergiesWithEU.length == 0}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) =>
                                                                item.inputName == "hasSynergiesWithNational"
                                                        )[0].listValue
                                                    }
                                                    label={
                                                        "Other relevant European Union programmes and funding instruments"
                                                    }
                                                    inputName={"hasSynergiesWithNational"}
                                                    value={data.hasSynergiesWithNational}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={
                                                        data.hasSynergiesWithNational.includes(
                                                            "Others EU programmes and/or funding instruments"
                                                        )
                                                            ? "Please specify which programmes"
                                                            : "Please provide concrete examples of projects and funding schemes/mechanisms"
                                                    }
                                                    textValid={
                                                        data.hasSynergiesWithNationalText.length > 4 ||
                                                        !data.hasSynergiesWithNational.includes(
                                                            "Others EU programmes and/or funding instruments"
                                                        )
                                                    }
                                                    textValue={data.hasSynergiesWithNationalText}
                                                    textName={"hasSynergiesWithNationalText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={
                                                        data.hasSynergiesWithNationalSensitive
                                                    }
                                                    confidentialInputName={
                                                        "hasSynergiesWithNationalSensitive"
                                                    }
                                                    display={data.hasSynergiesWithNational.length == 0}
                                                />
                                            </div>

                                            <div className="question-text much-margin-top">
                                                National and Regional Funding Programmes
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) =>
                                                                item.inputName == "hasSynergiesWithRegional"
                                                        )[0].listValue
                                                    }
                                                    label={""}
                                                    inputName={"hasSynergiesWithRegional"}
                                                    value={data.hasSynergiesWithRegional}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={
                                                        data.hasSynergiesWithRegional.includes(
                                                            "Other national governmental funding"
                                                        ) ||
                                                            data.hasSynergiesWithRegional.includes(
                                                                "Other regional governmental funding"
                                                            )
                                                            ? "Please specify which programmes"
                                                            : "Please provide concrete examples of projects and funding schemes/mechanisms"
                                                    }
                                                    textValid={
                                                        data.hasSynergiesWithRegionalText.length > 4 ||
                                                        !(
                                                            data.hasSynergiesWithRegional.includes(
                                                                "Other national governmental funding"
                                                            ) ||
                                                            data.hasSynergiesWithRegional.includes(
                                                                "Other regional governmental funding"
                                                            )
                                                        )
                                                    }
                                                    textValue={data.hasSynergiesWithRegionalText}
                                                    textName={"hasSynergiesWithRegionalText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={
                                                        data.hasSynergiesWithRegionalSensitive
                                                    }
                                                    confidentialInputName={
                                                        "hasSynergiesWithRegionalSensitive"
                                                    }
                                                    display={data.hasSynergiesWithRegional.length == 0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* ##### BBI ##### */}

                                <div className="impact-container">
                                    <CardHeader
                                        isHidden={socioEconomicImpactsIsHidden}
                                        toggleVisibility={toggleVisibilitySocioEconomicImpacts}
                                        cardName="Socio-economic Impacts "
                                        handleDelete={null}
                                    />
                                    {socioEconomicImpactsIsHidden ? (
                                        <div className="row">
                                            {/* ##### SET 2 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) => item.inputName == "scienceAndInnovation"
                                                        )[0].listValue
                                                    }
                                                    label={"Science and innovation"}
                                                    inputName={"scienceAndInnovation"}
                                                    value={data.scienceAndInnovation}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.scienceAndInnovationText.length > 4 ||
                                                        !data.scienceAndInnovation.includes("Others")
                                                    }
                                                    textValue={data.scienceAndInnovationText}
                                                    textName={"scienceAndInnovationText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.scienceAndInnovationSensitive}
                                                    confidentialInputName={
                                                        "scienceAndInnovationSensitive"
                                                    }
                                                    display={data.scienceAndInnovation.length == 0}
                                                />
                                            </div>

                                            {/* ##### SET 3 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) => item.inputName == "educationAndSociety"
                                                        )[0].listValue
                                                    }
                                                    label={"Education and society"}
                                                    inputName={"educationAndSociety"}
                                                    value={data.educationAndSociety}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.educationAndSocietyText.length > 4 ||
                                                        !data.educationAndSociety.includes("Others")
                                                    }
                                                    textValue={data.educationAndSocietyText}
                                                    textName={"educationAndSocietyText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.educationAndSocietySensitive}
                                                    confidentialInputName={"educationAndSocietySensitive"}
                                                    display={data.educationAndSociety.length == 0}
                                                />
                                            </div>

                                            {/* ##### SET 4 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) =>
                                                                item.inputName == "standardsRegulationsPolicies"
                                                        )[0].listValue
                                                    }
                                                    label={"Standards, regulations and policies "}
                                                    inputName={"standardsRegulationsPolicies"}
                                                    value={data.standardsRegulationsPolicies}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.standardsRegulationsPoliciesText.length > 4 ||
                                                        !data.standardsRegulationsPolicies.includes(
                                                            "Others"
                                                        )
                                                    }
                                                    textValue={data.standardsRegulationsPoliciesText}
                                                    textName={"standardsRegulationsPoliciesText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={
                                                        data.standardsRegulationsPoliciesSensitive
                                                    }
                                                    confidentialInputName={
                                                        "standardsRegulationsPoliciesSensitive"
                                                    }
                                                    display={
                                                        data.standardsRegulationsPolicies.length == 0
                                                    }
                                                />
                                            </div>

                                            {/* ##### SET 5 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) => item.inputName == "healthSafety"
                                                        )[0].listValue
                                                    }
                                                    label={"Health & safety"}
                                                    inputName={"healthSafety"}
                                                    value={data.healthSafety}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.healthSafetyText.length > 4 ||
                                                        !data.healthSafety.includes("Others")
                                                    }
                                                    textValue={data.healthSafetyText}
                                                    textName={"healthSafetyText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.healthSafetySensitive}
                                                    confidentialInputName={"healthSafetySensitive"}
                                                    display={data.healthSafety.length == 0}
                                                />
                                            </div>

                                            {/* ##### SET 6 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) =>
                                                                item.inputName == "impactOnPrimaryProducers"
                                                        )[0].listValue
                                                    }
                                                    label={
                                                        "Impact on primary producers (including in agriculture, forestry and marine sectors) and rural / coastal  development "
                                                    }
                                                    inputName={"impactOnPrimaryProducers"}
                                                    value={data.impactOnPrimaryProducers}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.impactOnPrimaryProducersText.length > 4 ||
                                                        !data.impactOnPrimaryProducers.includes("Others")
                                                    }
                                                    textValue={data.impactOnPrimaryProducersText}
                                                    textName={"impactOnPrimaryProducersText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={
                                                        data.impactOnPrimaryProducersSensitive
                                                    }
                                                    confidentialInputName={
                                                        "impactOnPrimaryProducersSensitive"
                                                    }
                                                    display={data.impactOnPrimaryProducers.length == 0}
                                                />
                                            </div>

                                            {/* ##### SET 7 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) =>
                                                                item.inputName == "regionalAndLocalImpact"
                                                        )[0].listValue
                                                    }
                                                    label={"Regional and local impact  "}
                                                    inputName={"regionalAndLocalImpact"}
                                                    value={data.regionalAndLocalImpact}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.regionalAndLocalImpactText.length > 4 ||
                                                        !data.regionalAndLocalImpact.includes("Others")
                                                    }
                                                    textValue={data.regionalAndLocalImpactText}
                                                    textName={"regionalAndLocalImpactText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.regionalAndLocalImpactSensitive}
                                                    confidentialInputName={
                                                        "regionalAndLocalImpactSensitive"
                                                    }
                                                    display={data.regionalAndLocalImpact.length == 0}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="impact-container">
                                    <CardHeader
                                        isHidden={environmentalImpactIsHidden}
                                        toggleVisibility={toggleVisibilityEnvironmentalImpact}
                                        cardName="Environmental Impacts"
                                        handleDelete={null}
                                    />
                                    {environmentalImpactIsHidden ? (
                                        <div className="row">
                                            {/* ##### SET 8 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) => item.inputName == "environmentalImpact"
                                                        )[0].listValue
                                                    }
                                                    label={"Enviromental impact"}
                                                    inputName={"environmentalImpact"}
                                                    value={data.environmentalImpact}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.environmentalImpactText.length > 4 ||
                                                        !data.environmentalImpact.includes("Others")
                                                    }
                                                    textValue={data.environmentalImpactText}
                                                    textName={"environmentalImpactText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.environmentalImpactSensitive}
                                                    confidentialInputName={"environmentalImpactSensitive"}
                                                    display={data.environmentalImpact.length == 0}
                                                />
                                            </div>

                                            {/* ##### SET 9 BBI ##### */}

                                            <div className="col-md-6 col-sm-12">
                                                <DropDTextMultiple
                                                    listInputs={
                                                        dropdownValues.filter(
                                                            (item) =>
                                                                item.inputName == "contributesBiodiversity"
                                                        )[0].listValue
                                                    }
                                                    label={
                                                        "Does the project contributes to preserve and/or enhance biodiversity in"
                                                    }
                                                    inputName={"contributesBiodiversity"}
                                                    value={data.contributesBiodiversity}
                                                    handleOnChange={handleOnChangeImpacts}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <TextConfidential
                                                    label={"Please explain"}
                                                    textValid={
                                                        data.contributesBiodiversityText.length > 4 ||
                                                        !data.contributesBiodiversity.includes("Others")
                                                    }
                                                    textValue={data.contributesBiodiversityText}
                                                    textName={"contributesBiodiversityText"}
                                                    onChange={handleOnChangeImpacts}
                                                    isConfidential={data.contributesBiodiversitySensitive}
                                                    confidentialInputName={
                                                        "contributesBiodiversitySensitive"
                                                    }
                                                    display={data.contributesBiodiversity.length == 0}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        
    );
}
export default Impacts;

const ListOfTwenty: string[] = ["-"].concat(
    Array.from({ length: 21 }, (_, index) => index.toString())
);
